import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid, CircularProgress } from '@mui/material';
import { JFields, JFormikInitialValues, JItem } from '../forms';
import { Formik, FormikHelpers } from 'formik';
import { AnyObject, OptionalObjectSchema, TypeOfShape } from 'yup/lib/object';

export interface AlertFormProps {
  open: boolean;
  isLoading?: boolean;
  title?: string;
  text?: string;
  button?: string;
  initialValues?: JFormikInitialValues | object;
  form?: JItem[];
  validationSchema?: OptionalObjectSchema<{}, AnyObject, TypeOfShape<{}>>;
  onClose?: Function;
  onConfirm?: Function;
  sx?: any;
  PaperProps?: any;
}

export const AlertForm = ({
  open,
  title = '',
  text = '',
  form = [],
  button = '',
  initialValues,
  validationSchema,
  onClose = () => {},
  isLoading = false,
  onConfirm = () => {},
  sx,
  PaperProps,
}: AlertFormProps) => {
  return (
    <div>
      <Dialog
        fullWidth
        maxWidth={'md'}
        open={open}
        onClose={() => onClose()}
        sx={{ ...(sx || {}) }}
        PaperProps={PaperProps}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        {text && <DialogContentText>{text}</DialogContentText>}
        <Formik
          initialValues={initialValues || {}}
          onSubmit={(values: any, formikHelpers: FormikHelpers<any>) =>
            onConfirm && onConfirm(values)
          }
          validationSchema={validationSchema}
        >
          {({ handleSubmit, values, errors }) => {
            {
              errors && Object.keys(errors).length > 1 && console.error(errors);
            }
            return (
              <form onSubmit={handleSubmit}>
                <DialogContent sx={{ minWidth: '300px' }}>
                  <Grid container spacing={2}>
                    <JFields items={form} />
                  </Grid>
                </DialogContent>

                <DialogActions>
                  <Button type="submit" color="secondary">
                    {button}
                    {isLoading && (
                      <CircularProgress
                        color="inherit"
                        size={16}
                        className="ml-4"
                      />
                    )}
                  </Button>

                  <Button color="secondary" onClick={() => onClose()} autoFocus>
                    Cancel
                  </Button>
                </DialogActions>
                {false && <pre>{JSON.stringify(values, null, 2)}</pre>}
              </form>
            );
          }}
        </Formik>
      </Dialog>
    </div>
  );
};
